<template>
  <div>
    <v-btn color="primary"
           @click="goBack"
    >
      <v-icon class="mr-2">mdi-keyboard-return</v-icon>
      {{ languageData.backBtn }}
    </v-btn>
  </div>
</template>

<script>
  export default{
    name: "BackButton",
    methods: {
      goBack() {
        this.$router.back()
      },
    }
  };
</script>
